module.exports = __webpack_public_path__ + "static/media/camera.da349778.svg";